import { render, staticRenderFns } from "./PartTag.vue?vue&type=template&id=e03f25ae&"
import script from "./PartTag.vue?vue&type=script&lang=js&"
export * from "./PartTag.vue?vue&type=script&lang=js&"
import style0 from "./PartTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VExpandTransition,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e03f25ae')) {
      api.createRecord('e03f25ae', component.options)
    } else {
      api.reload('e03f25ae', component.options)
    }
    module.hot.accept("./PartTag.vue?vue&type=template&id=e03f25ae&", function () {
      api.rerender('e03f25ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelTagging/PartTag.vue"
export default component.exports